import React from "react";

import CaretRight from "src/assets/Icons/Caret-Right.svg";
import { Button } from "src/libraries/mui/components";
import { TenantType } from "src/store/graphql/helpers/types.graphql";
import * as Styled from "./styles";

interface ITenantSelectionCardProps {
  tenant: TenantType;
  onClick: (tenantId: string) => void;
}

const TenantSelectionCard: React.FC<ITenantSelectionCardProps> = ({ tenant, onClick }) => (
  <Styled.Container>
    <Styled.Name>{tenant.name}</Styled.Name>
    <Button disableRipple onClick={() => onClick(tenant.id)} className="caret-right-button">
      <Styled.CaretRight
        alt="kanban card caret right"
        src={CaretRight}
      />
    </Button>
  </Styled.Container>
);

export default TenantSelectionCard;